import SkuDisplay from "../../../Common/components/SkuDisplay";
import NapaSkuDisplay from "../../../ProductGroupPage/components/StandardItems/NapaSkuDisplay";
import _ from "lodash";
import React from "react";
import CartItemVehicle from "./CartItemVehicle";
import CartItemTitle from "./CartItemTitle";
import LocalUrlMaker from "../../../lib/LocalUrlMaker";
import pluralize from 'pluralize';

export default function CartItemDetail({item, url}) {
  url ||= LocalUrlMaker.prefixedPath(item.groupUrl);

  // suppress name if it matches group name (singular or plural)
  let hideItemName = nameMatches(item.groupName, item.name);

  return <div className="product-details col-span-4 lg:col-span-5 text-sm">
    <CartItemTitle item={item} url={url}/>

    {!hideItemName && <div className="item-name">{item.name}</div>}

    <div className="">
      <SkuDisplay sku={item.vendorsku} tagName="div"/>

      <NapaSkuDisplay sku={item.fullNapaSku} tagName="div"/>

      <CartItemVehicle item={item}/>

      <div className="options">
        {(item.cartItemOptions || [])
          .map((opt) => <CartItemOptionDisplay key={opt.name} {...opt} />)}
      </div>

      {(_.values(item.qualities))
        .map((qual, i) => <CartItemQuality key={i} {...qual} />)}
    </div>

  </div>
}

function nameMatches(name1, name2) {
  if (name1 === name2)
    return true;

  let p1 = pluralize(name1);
  let p2 = pluralize(name2);

  if (p1 === p2 || p1 === name2 || p2 === name1)
    return true;

  return false;
}

// Qualities, aka attributes; "Color: Black", that sort of thing.
function CartItemQuality({label, values}) {
  return <div className="item-quality">
    <strong>{label}: </strong>
    <strong>{values}</strong>
  </div>
}

function CartItemOptionDisplay({displayName, displayValue, regularUnitPrice}) {
  let dollars = regularUnitPrice ? new Money(regularUnitPrice).toString() : null;

  return <div className="item-option">
    <span>{displayName}: </span>
    <span>{displayValue} </span>
    {dollars && <span> {dollars.toString()} </span>}
  </div>
}
